import { FC, ReactNode } from 'react'
import { Link } from '@/libs'
import { ComponentState } from '@/states'
import { ScrollTop } from '@/helpers'
import { LogoIcon } from '@/ui/icons'
import { COMPONENT_DEFUALT_FILTERS } from '@/data'

const LogoSection: FC = (): ReactNode => {
    const { SetState } = ComponentState()

    const HardReset = () => {
        ScrollTop()
        SetState({ Filters: structuredClone(COMPONENT_DEFUALT_FILTERS) })
    }

    return (
        <div className='flex justify-start items-center hover:opacity-80 transition-all ease-in-out duration-500'>
            <Link href='/' onClick={HardReset} className='flex mr-4'>
                <LogoIcon />
            </Link>
        </div>
    )
}

export default LogoSection
